export default {
  LK: {
    pageTitle: "Личный кабинет",
    subscription: {
      yourSubs: "Ваша подписка",
      plan_1: "Бесплатная",
      plan_2: "Расширенная",
      plan_3: "Индивидуальная",
      changePlan: "Изменить тариф",
      activeFor: "Активна до",
      nextPayment: "Следующее списание",
      accessFor: "Доступ открыт до",
      expired: "Закончилась",
    },
    eduSubs: "Образовательная подписка",
    settings: "Настройки",
    form: {
      labels: {
        status: "Статус",
        spec_med: "Специальность",
        position: "Должность",
        university: "ВУЗ",
      },
    },
    verifyBanner: {
      step1: {
        title: "Подтвердите учетную запись",
        agenda:
          "Необходимо для доступа к загрузке и обработке исследований искусственным интеллектом",
        status: "Cтатус",
      },
      step2: {
        title: "Подтвердите учетную запись",
        agenda:
          "Необходимо для доступа к загрузке и обработке исследований искусственным интеллектом",
        chooseVerifyWay: "Выберите способ подтверждения",
        ways: {
          1: "Диплом, сертификат или удостоверение",
          2: "Ссылка на свою подтвержденную страницу на медицинском агрегаторе (Продокторов, DocDoc и др.)",
          3: "Ссылка на свою страницу на сайте клиники",
          4: "Загрузите диплом о медицинском образовании",
          5: "Загрузите студенческий билет медицинского вуза",
        },
        selectFile: "Выберите файл",
        sendToCheck: "Отправить на проверку",
        pasteLink: "Вставьте ссылку",
        notAllowedFile: "Допустимы только PDF и изображения.",
        noMoreFiles: "Максимальное количество файлов - ",
      },
      step3: {
        processing: {
          title: "Документ отправлен на проверку",
          text1_1:
            "Ваши данные находятся на рассмотрении. Мы проверим их в ближайшее время и уведомим вас о статусе подтверждения. Обычно это занимает 1 рабочий день",
        },
        rejected: {
          title: "Учетная запись не подтверждена",
          text1_1:
            "Ваши данные не прошли проверку. Пожалуйста, отправьте корректные данные. Это необходимо для получения доступа к загрузке и обработке исследований искусственным интеллектом",
          text1_2: "Попробовать снова",
        },
        accepted: {
          title: "Учетная запись подтверждена",
          text1_1:
            "Теперь у вас есть доступ к загрузке и обработке исследований искусственным интеллектом",
        },
      },
    },
  },
};
